module.exports = __webpack_public_path__ + "img/download-pencil-outline-green.6f3be5dc.svg";